import { constant } from "../../config.js";
import commonUtils from "../common-utlis.js";
import requestUtil from "../request-utils.js";
import { getTimelinesData, setTimelinesData } from "./data-refresh.js";
import { getParam } from "./api-params.js";

class Sys {
	sysTimestamp;
	async getSysTime(isRefresh = false) {
		let needRefreshJudge = getTimelinesData(constant.DATA_KEY_SYS_TIMESTAMP, true);
		// 如果需要获取最新数据，则不读取缓存
		if (!!this.sysTimestamp && !!needRefreshJudge && !isRefresh) {
			// 如果数据存在则直接返回，否则调用接口获取最新数据
			return this.sysTimeStamp;
		}
		this.sysTimeStamp = await this.getSysTimeFromOrigion();

		setTimelinesData(constant.DATA_KEY_SYS_TIMESTAMP, this.sysTimeStamp, true);

		try {
			window.clearInterval(timeInterval);
		} catch (e) {
			//TODO handle the exception
		}

		let timeInterval = setInterval(() => {
			this.sysTimestamp += 1000;
		}, 1000);

		// 返回系统时间
		return this.sysTimeStamp;
	}
	getSysTimeFromOrigion() {
		return new Promise((resolve, reject) => {
			requestUtil.jackyunPost(
				{
					method: "sys.getsystimestamp",
				},
				function (data) {
					if (data.code == 200) {
						resolve(data.msg);
					} else {
						console.log("系统时间戳获取失败：" + data.msg);
						return resolve(0);
					}
				}
			);
		});
	}

	// 用户信息
	customerId;
	// 获取登录人信息
	getCustomerId() {
		// 返回系统时间
		return this.customerId;
	}
	// 设置登录人信息
	setCustomerId(customerId) {
		// 返回系统时间
		this.customerId = customerId;
	}

	distributorId;
	// 获取登录人信息
	getDistributorId() {
		// 返回系统时间
		return this.distributorId;
	}

	// 设置登录人信息
	setDistributorId(distributorId) {
		// 返回系统时间
		this.distributorId = distributorId;
	}

	// 货品级限购 参照对象数组
	goodsLimitDataList;
	// 获取货品级限购信息
	getGoodsLimitDataList() {
		// 返回系统时间
		return this.goodsLimitDataList;
	}
	// 设置货品级限购数据
	setGoodsLimitDataList(goodsLimitDataList) {
		this.goodsLimitDataList = goodsLimitDataList;
	}
}

var system = new Sys();

//可以被外部引用的方法
export { system };
